import { render, staticRenderFns } from "./EstatusDespacho.vue?vue&type=template&id=fc073fa4"
import script from "./EstatusDespacho.vue?vue&type=script&lang=js"
export * from "./EstatusDespacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports